import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-ubs-blog-comments',
  templateUrl: './ubs-blog-comments.component.html',
  styleUrls: ['./ubs-blog-comments.component.scss']
})
export class UbsBlogCommentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
